import { SchedulerForm, SchedulerFormProps } from '@progress/kendo-react-scheduler';
import { useCallback } from 'react';
import { AppConstants, diaryErrorMessages } from '../Shared/Constants/AppConstant';
import { CustomDialog } from './CustomDialog';
import { CustomFormEditor } from './CustomFormEditor';
import { useNavigate } from "react-router-dom";

export const FormWithCustomEditor = (props: SchedulerFormProps, dairyActivityList: any, activityList: any, employerList: any, deleteActivty: any) => {
    let newProps = { ...props };
    const navigate = useNavigate();
    const intersects = (
        startTime1: Date,
        endTime1: Date,
        startTime2: Date,
        endTime2: Date
    ) =>
        (startTime1 < startTime2 && endTime1 > endTime2) ||
        (startTime2 <= startTime1 && startTime1 < endTime2) ||
        (startTime2 < endTime1 && endTime1 <= endTime2);

    //To hide or show recurrence editor in activity popup
    const isShowRecurrenceEditor = () => {
        //Hide if editing occurence
        if (props.dataItem.recurrenceId && props.dataItem.recurrenceRule) {
            return false;
        }
        //Hide for expanded events from series
        if (props.dataItem.recurrenceId && !props.dataItem.recurrenceRule) {
            return false;
        }
        return true;
    }

    const showRecurrenceEditor = isShowRecurrenceEditor();

    // Required validation for all the fields
    const requiredValidator = useCallback(
        (value: any, fieldName: string) =>
        (value === undefined || value === null || value === '' || value === 0
            ? `${fieldName} field is required.`
            : undefined),
        []
    );

    const notesValidator = useCallback(
        (value: any, fieldName: string) =>
            (value && value.length > 300 ? `${fieldName} should not exceed 300 characters.` : ''),
        []
    );

    const dateValidator = useCallback(
        (startDate: any, endDate: any) =>
            (startDate >= endDate ? `Start time must be before end time.` : undefined),
        []
    );

    const conflictValidator = useCallback((jobSubCategoryId: any, startDate: any, endDate: any, id: Number) =>
        (checkDiaryActivityConflicts(jobSubCategoryId, startDate, endDate, id)),
        []
    );

    //To validate for any diary conflicts 
    const checkDiaryActivityConflicts = (jobSubCategoryId: any, startDate: any, endDate: any, id: Number) => {
        let errorMsg = undefined;
        if (!props.dataItem.recurrenceRule) {
            //To get current activity job sub-category
            let jobSubCategory = activityList.filter((x: any) => x.jobSubCategoryId == jobSubCategoryId)[0];

            let employerIds: any = [];
            //Add all the un-archieved employer ids 
            employerList.map((employer: any) => {
                employerIds.push(employer.id);
            })

            //checking any activities for selected date and time
            var existingBreakActivity = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.breakSubCategoryName && (x.id != id)
                && intersects(startDate, endDate, x.start, x.end));

            //To check any activity exists for archieved employer
            if (existingBreakActivity.length > 0) {
                if (existingBreakActivity.every((x: any) => !employerIds.includes(x.memberEmployerId))) {
                    errorMsg = diaryErrorMessages.isArchievedEmployerActivityExist;
                }
            }
            if (errorMsg) {
                return errorMsg;
            }
            //checking break activities for selected date and time
            let isBreakExist = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.breakSubCategoryName && (x.id != id)
                && intersects(startDate, endDate, x.start, x.end)).length;
            errorMsg = (isBreakExist > 0) ? diaryErrorMessages.isBreakExist : undefined;
            if (errorMsg) {
                return errorMsg;
            }
            if (jobSubCategory.jobSubCategoryName == AppConstants.leaveSubCategoryName) {
                //checking any activities for selected date and time
                var existingDutydayActivity = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.dutyDaySubCategoryName && (x.id != id)
                    && intersects(startDate, endDate, x.start, x.end));

                //To check any activity exists for archieved employer
                if (existingDutydayActivity.length > 0) {
                    if (existingDutydayActivity.every((x: any) => !employerIds.includes(x.memberEmployerId))) {
                        errorMsg = diaryErrorMessages.isArchievedEmployerActivityExist;
                    }
                }
                if (!errorMsg) {
                    //checking duty day activities for leave activity for selected date and time
                    let isDutyDayExist = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.dutyDaySubCategoryName && (x.id != id)
                        && intersects(startDate, endDate, x.start, x.end)).length;
                    errorMsg = (isDutyDayExist > 0) ? diaryErrorMessages.isDutyDayExistForLeave : undefined;
                }
                if (!errorMsg) {
                    var existingLeaveActivity = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.leaveSubCategoryName && (x.id != id)
                        && intersects(startDate, endDate, x.start, x.end));

                    //To check any activity exists for archieved employer
                    if (existingLeaveActivity.length > 0) {
                        if (existingLeaveActivity.every((x: any) => !employerIds.includes(x.memberEmployerId))) {
                            errorMsg = diaryErrorMessages.isArchievedEmployerActivityExist;
                        }
                    }
                }
                if (!errorMsg) {
                    //checking leave activities for selected date and time
                    let isLeaveExist = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.leaveSubCategoryName && (x.id != id)
                        && intersects(startDate, endDate, x.start, x.end)).length;
                    errorMsg = (isLeaveExist > 0) ? diaryErrorMessages.isLeaveExist : undefined;
                }
            }
            else if (jobSubCategory.jobSubCategoryName == AppConstants.dutyDaySubCategoryName) {
                var existingLeaveActivity = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.leaveSubCategoryName && (x.id != id)
                    && intersects(startDate, endDate, x.start, x.end));

                //To check any activity exists for archieved employer
                if (existingLeaveActivity.length > 0) {
                    if (existingLeaveActivity.every((x: any) => !employerIds.includes(x.memberEmployerId))) {
                        errorMsg = diaryErrorMessages.isArchievedEmployerActivityExist;
                    }
                }
                if (!errorMsg) {
                    //checking leave activities for duty day selected date and time
                    let isLeaveExist = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.leaveSubCategoryName && (x.id != id)
                        && intersects(startDate, endDate, x.start, x.end)).length;
                    errorMsg = (isLeaveExist > 0) ? diaryErrorMessages.isLeaveExistForDutyday : undefined;
                }
                if (!errorMsg) {
                    var existingDutydayActivity = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.dutyDaySubCategoryName && (x.id != id)
                        && intersects(startDate, endDate, x.start, x.end));

                    //To check any activity exists for archieved employer
                    if (existingDutydayActivity.length > 0) {
                        if (existingDutydayActivity.every((x: any) => !employerIds.includes(x.memberEmployerId))) {
                            errorMsg = diaryErrorMessages.isArchievedEmployerActivityExist;
                        }
                    }
                }
                if (!errorMsg) {
                    //checking duty day activities for selected date and time
                    let isDutyDayExist = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.dutyDaySubCategoryName && (x.id != id)
                        && intersects(startDate, endDate, x.start, x.end)).length;
                    errorMsg = (isDutyDayExist > 0) ? diaryErrorMessages.isDutyDayExistForDutyOnCall : undefined;
                }
            }
            else if (jobSubCategory.jobSubCategoryName == AppConstants.breakSubCategoryName) {
                var existingDutydayActivity = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.dutyDaySubCategoryName && (x.id != id)
                    && intersects(startDate, endDate, x.start, x.end));

                //To check any activity exists for archieved employer
                if (existingDutydayActivity.length > 0) {
                    if (existingDutydayActivity.every((x: any) => !employerIds.includes(x.memberEmployerId))) {
                        errorMsg = diaryErrorMessages.isArchievedEmployerActivityExist;
                    }
                }
                //checking duty day activities for selected date and time
                if (!errorMsg) {
                    let isDutyDayExist = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.dutyDaySubCategoryName && (x.id != id)
                        && intersects(startDate, endDate, x.start, x.end)).length;
                    errorMsg = (isDutyDayExist > 0) ? diaryErrorMessages.isDutyDayExist : undefined;
                }
                if (!errorMsg) {
                    var existingLeaveActivity = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.leaveSubCategoryName && (x.id != id)
                        && intersects(startDate, endDate, x.start, x.end));

                    //To check any activity exists for archieved employer
                    if (existingLeaveActivity.length > 0) {
                        if (existingLeaveActivity.every((x: any) => !employerIds.includes(x.memberEmployerId))) {
                            errorMsg = diaryErrorMessages.isArchievedEmployerActivityExist;
                        }
                    } 
                }
                if (!errorMsg) {
                    //checking leave activities for selected date and time
                    let isLeaveExist = dairyActivityList.filter((x: any) => x.jobSubCategoryName == AppConstants.leaveSubCategoryName && (x.id != id)
                        && intersects(startDate, endDate, x.start, x.end)).length;
                    errorMsg = (isLeaveExist > 0) ? diaryErrorMessages.isLeaveExist : undefined;
                }
                if (!errorMsg) {
                    var existingActivity = dairyActivityList.filter((x: any) => (x.jobSubCategoryName != AppConstants.leaveSubCategoryName)
                                                                                 && (x.jobSubCategoryName != AppConstants.dutyDaySubCategoryName)
                                                                                 && (x.jobSubCategoryName != AppConstants.breakSubCategoryName)
                                                                                 && (x.id != id) && intersects(startDate, endDate, x.start, x.end));

                    //To check any activity exists for archieved employer
                    if (existingActivity.length > 0) {
                        if (existingActivity.every((x: any) => !employerIds.includes(x.memberEmployerId))) {
                            errorMsg = diaryErrorMessages.isArchievedEmployerActivityExist;
                        }
                    }
                }
                if (!errorMsg) {
                    //checking any activities for selected date and time
                    let isActivityExist = dairyActivityList.filter((x: any) => (x.jobSubCategoryName != AppConstants.leaveSubCategoryName) && (x.jobSubCategoryName != AppConstants.dutyDaySubCategoryName)
                        && (x.jobSubCategoryName != AppConstants.breakSubCategoryName)
                        && (x.id != id) && intersects(startDate, endDate, x.start, x.end)).length;
                    errorMsg = (isActivityExist > 0) ? diaryErrorMessages.isActivityExist : undefined;
                }
            }
            else {
                var existingActivity = dairyActivityList.filter((x: any) => (x.jobSubCategoryName != AppConstants.leaveSubCategoryName)
                    && (x.jobSubCategoryName != AppConstants.dutyDaySubCategoryName)
                    && (x.jobSubCategoryName != AppConstants.breakSubCategoryName)
                    && (x.id != id) && intersects(startDate, endDate, x.start, x.end));

                //To check any activity exists for archieved employer
                if (existingActivity.length > 0) {
                    if (existingActivity.every((x: any) => !employerIds.includes(x.memberEmployerId))) {
                        errorMsg = diaryErrorMessages.isArchievedEmployerActivityExist;
                    }
                }
                if (!errorMsg) {
                    //checking any activities for selected date and time
                    let isActivityExist = dairyActivityList.filter((x: any) => (x.jobSubCategoryName != AppConstants.leaveSubCategoryName)
                        && (x.jobSubCategoryName != AppConstants.breakSubCategoryName)
                        && (x.jobSubCategoryName != AppConstants.dutyDaySubCategoryName)
                        && (x.id != id) && intersects(startDate, endDate, x.start, x.end)).length;
                    errorMsg = (isActivityExist > 0) ? diaryErrorMessages.isActivityExist : undefined;
                }
            }
        }
        return errorMsg;
    }

    // To validate for all the fields in activity pop-up
    const formValidator = (_dataItem: any, formValueGetter: any) => {
        let result: any = {};

        //To validate for any diary conflicts
        if (_dataItem.memberEmployerId && _dataItem.jobSubCategoryId && _dataItem.start && _dataItem.end) {
            result.activityConflictsError = [
                conflictValidator(formValueGetter('jobSubCategoryId'), formValueGetter('start'), formValueGetter('end'), formValueGetter('id'))
            ].filter(Boolean).reduce((current, acc) => current || acc, '');
        }

        //To validate other activity
        if (_dataItem.jobSubCategoryId && _dataItem.jobSubCategoryId == AppConstants.otherActivitySubCatgoryId) {
            navigate(`/workActivity`);
        }

        result.memberEmployerId = [
            requiredValidator(formValueGetter('memberEmployerId'), 'Employer')
        ].filter(Boolean).reduce((current, acc) => current || acc, '');

        result.jobSubCategoryId = [
            requiredValidator(formValueGetter('jobSubCategoryId'), 'Activity')
        ].filter(Boolean).reduce((current, acc) => current || acc, '');

        result.notes = [
            notesValidator(formValueGetter('notes'), 'Notes')
        ].filter(Boolean).reduce((current, acc) => current || acc, '');

        result.start = [
            requiredValidator(formValueGetter('start'), 'Start date')
        ].filter(Boolean).reduce((current, acc) => current || acc, '');

        result.end = [
            requiredValidator(formValueGetter('end'), 'End date')
        ].filter(Boolean).reduce((current, acc) => current || acc, '');

        if (!result.end) {
            result.end = [
                dateValidator(formValueGetter('start'), formValueGetter('end'))
            ].filter(Boolean).reduce((current, acc) => current || acc, '');
        }
        return result;
    };

    // custom-form for activity pop-up
    return (props.dataItem.isPublicHoliday ? null :
        <SchedulerForm
            {...props}
            editor={(props) => CustomFormEditor(props, activityList, employerList, showRecurrenceEditor, dairyActivityList, newProps.dataItem)}
            dialog = {(props) => CustomDialog(props, newProps, deleteActivty)}
            validator={formValidator}
        />
    )
};